export default __webpack_public_path__ + "static/media/avax.ef08fa98.svg";